import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';

import * as _ from 'lodash';
import {takeWhile} from 'rxjs/operators';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';


@Component({
  moduleId: module.id,
  selector: 'hidden-scroll',
  templateUrl: 'hidden-scroll.component.html',
  styleUrls: ['hidden-scroll.component.scss']
})
export class HiddenScrollComponent implements OnInit, OnDestroy, AfterViewInit {

  contentWrapWidth: number;

  @HostBinding('class.table-editable-scroll')
  @Input() tableDefault: boolean = false;

  @ViewChild('scroll', {static: false}) scroll: ElementRef | void;

  private isActive: boolean = true;

  constructor(
    private ngZone: NgZone,
    private ref: ChangeDetectorRef,
    private elementRef: ElementRef,
  ) {}

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(window, 'resize')
      .pipe(takeWhile(() => this.isActive))
      .subscribe(() => {
        _.throttle(() => {
          this.defineContentWidth(true);
        }, 200)();
      });
    });
  }

  ngAfterViewInit() {
    this.defineContentWidth(true);
  }

  ngOnDestroy() {
    this.isActive = false;
  }

  public scrollTo(value: number) {
    if (this.scroll) {
      this.scroll.nativeElement.scrollTop = value;
    }
  }

  public scrollToBottom() {
    if (!this.scroll) {
      return;
    }
    const element = this.scroll.nativeElement;
    element.scrollTop = element.scrollHeight;
  }

  public defineContentWidth(markForCheck: boolean = false): void {
    _.defer(() => {
      this.setContentWidth(this.elementRef.nativeElement.offsetWidth);
      if (markForCheck) { this.ref.markForCheck(); }
    });
  }

  public setContentWidth(width: number): void {
    this.contentWrapWidth = width;
  }
}
